import { connect } from 'react-redux';

import { GlobalState } from 'ha/types/store';
import { getOtherFiltersCount } from 'ha/pages/Search/selectors';
import OtherFilterButton from 'ha/components/Filters/OtherFilterButton';

const mapStateToProps = (state: GlobalState) => ({
  count: getOtherFiltersCount(state),
});

export default connect(mapStateToProps)(OtherFilterButton);
